<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/activity/add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1),  fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      filterable
      style="float: right"
      v-model="screen.doing_status"
      placeholder="请选择活动状态"
    >
      <el-option
        :label="item.title"
        :value="item.val"
        v-for="(item, index) in doingList"
        :key="index"
      ></el-option>
    </el-select>
    <el-select
      filterable
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      max-height="700"  v-loading="listLoading" 
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区">
        <template slot-scope="scope">
          <span>{{ scope.row.park_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="举办地点" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动预览图" min-width="200">
        <template slot-scope="scope">
          <!-- <img
            v-if="scope.row.thumb"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageUrl + scope.row.thumb"
          /> -->
          <el-image
            style="width: 170px; height: 100px; margin: 0 5px 5px 0"
            :src="imageOss + scope.row.thumb.split(',')[0]"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.thumb.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="活动范围">
        <template slot-scope="scope">
          <span>{{ scope.row.join_type == 1 ? "本园区" : "全部园区" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动时间" width="300" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.start_text }}</div>
          至
          <div>{{ scope.row.end_text }}</div>
        </template>
      </el-table-column>
      <el-table-column label="报名时间" width="300" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.start_join_text }}</div>
          至
          <div>{{ scope.row.end_join_text }}</div>
        </template>
      </el-table-column>
      <el-table-column label="活动状态" width="100">
        <template slot-scope="scope">
          {{
            scope.row.doing_status == 1
              ? "活动未开始"
              : scope.row.doing_status == 2
              ? "活动报名中"
              : scope.row.doing_status == 3
              ? "报名已截止"
              : scope.row.doing_status == 4
              ? "活动进行中"
              : "活动已结束"
          }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="发布时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="340" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/activity/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/activity/del')"
            >删除</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="getRegisterUser(scope.row.id)"
            v-if="roles.includes('/activity/user_lists')"
            >报名列表</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="openComment(scope.row.id)"
            v-if="roles.includes('/activity/comment_lists')"
            >评论管理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动预览图" prop="thumb">
          <el-upload
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
          <div class="pic-tips">图片宽高比建议 5:4</div>
        </el-form-item>

        <el-form-item label="报名时间" prop="applyTime">
          <el-date-picker
            v-model="ruleForm.applyTime"
            type="datetimerange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="报名开始日期"
            end-placeholder="报名结束日期"
          >
            <!-- :disabled="ruleForm.activityTime == null" -->
            <!-- @change="applyChange" -->
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动时间" prop="activityTime">
          <el-date-picker
            v-model="ruleForm.activityTime"
            type="datetimerange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="活动开始日期"
            end-placeholder="活动结束日期"
            @change="applyChange"
          >
            <!-- @change="activityChange" -->
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动园区" prop="join_type">
          <el-radio-group
            v-model="ruleForm.join_type"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">仅本园区</el-radio>
            <el-radio :label="2">所有园区</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否党员活动" prop="is_party">
          <el-radio-group
            v-model="ruleForm.is_party"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="0">不是</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动地点" prop="address">
          <el-input
            type="textarea"
            :rows="2"
            class="w4"
            v-model="ruleForm.address"
            placeholder="请输入活动地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动性质" prop="nature">
          <el-input
            class="w4"
            v-model="ruleForm.nature"
            placeholder="请输入活动性质"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动详情" prop="content">
          <Editor
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      size="800px"
      title="评论管理"
      :visible.sync="commentVisble"
      direction="rtl"
    >
      <div class="comment_list" v-if="commentList.length">
        <div
          class="comment_item"
          v-for="(item, index) in commentList"
          :key="index"
        >
          <div class="comment_user">
            <img
              class="avatar"
              :src="
                item.user.avatar_url
                  ? imageOss + item.user.avatar_url
                  : 'https://zhongzhou-image.oss-cn-hangzhou.aliyuncs.com/uploads/mini/baseimage/20230731/1690784281default_head.png'
              "
              alt=""
            />
            <div class="userName">{{ item.user.name || "--" }}</div>
          </div>
          <div class="comment_content">
            <div class="contetns">
              {{ item.content || "--" }}
            </div>
            <div class="comment_time">
              <div class="time">
                {{ item.create_time || "--" }}
              </div>
              <div
                class="audit"
                v-if="
                  roles.includes('/activity/comment_audit') &&
                  item.audit_status == 1 &&
                  !item.delete_time
                "
                @click="auditComment(item, index, 'main')"
              >
                审核通过
              </div>
              <div
                class="del"
                v-if="
                  roles.includes('/activity/comment_del') && !item.delete_time
                "
                @click="delComment(item, index, 'main')"
              >
                删除
              </div>
            </div>
            <div
              class="comment_item"
              v-for="(subItem, subIndex) in item.son_lists"
              :key="subIndex"
            >
              <div class="comment_user">
                <img
                  class="avatar"
                  :src="
                    subItem.user.avatar_url
                      ? imageOss + subItem.user.avatar_url
                      : 'https://zhongzhou-image.oss-cn-hangzhou.aliyuncs.com/uploads/mini/baseimage/20230731/1690784281default_head.png'
                  "
                  alt=""
                />
                <div class="userName">{{ subItem.user.name || "--" }}</div>
              </div>
              <div class="comment_content">
                <div class="contetns">
                  <span class="samll_feedback" v-if="subItem.p_user">回复@{{subItem.p_user.user.name}}</span>{{ subItem.content || "--" }}
                </div>
                <div class="comment_time">
                  <div class="time">
                    {{ subItem.create_time || "--" }}
                  </div>
                  <div
                    class="audit"
                    v-if="
                      roles.includes('/activity/comment_audit') &&
                      subItem.audit_status == 1 &&
                      !subItem.delete_time
                    "
                    @click="auditComment(item, index, 'sub', subItem, subIndex)"
                  >
                    审核通过
                  </div>
                  <div
                    class="del"
                    v-if="
                      roles.includes('/activity/comment_del') &&
                      !subItem.delete_time
                    "
                    @click="delComment(item, index, 'sub', subItem, subIndex)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </div>
            <div
              class="more"
              v-if="item.son_count > item.son_lists.length"
              @click="moreSubComment(item, index)"
            >
              查看更多回复
            </div>
          </div>
        </div>
        <div
          class="more"
          v-if="commentPage * commentPageSize < commentTotal"
          @click="
            () => {
              commentPage++;
              getCommentList();
            }
          "
        >
          查看更多评论
        </div>
      </div>
      <div class="comment_empty" v-else>
        <el-empty description="暂无评价信息" :image-size="130"></el-empty>
      </div>
    </el-drawer>
    <el-dialog title="活动报名列表" :visible.sync="dialogVisible" width="60%">
      <el-input
        class="screenInput"
        v-model="registerUser.like"
        placeholder="模糊搜索"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(registerUser.page = 1), getRegisteredList()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="UserCZhi()"
        >重置</el-button
      >
      <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/activity/user_export')"
        >导出</el-button
      >
      <el-table
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        v-loading="userLoading"
        :data="registerUserList"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (registerUser.page - 1) * registerUser.page_size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <!-- <el-table-column label="头像">
        <template slot-scope="scope">
          <img :src="scope.row.avatar_url" alt="">
        </template>
      </el-table-column> -->
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称">
          <template slot-scope="scope">
            <span>{{ scope.row.nick_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报名时间">
          <template slot-scope="scope">
            {{ scope.row.join_time }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :page-size="registerUser.page_size"
          @current-change="registerPageChange"
          layout="prev, pager, next"
          :current-page="registerUser.page"
          :total="registerUser.total"
        >
        </el-pagination>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  activityLists,
  addActivity,
  activityDetail,
  editActivity,
  delActivity,
  openPark,
  delImage,
  activityRegistered,
  activity_comment_lists,
  activity_comment_del,
  activity_comment_audit,
  user_export,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      commentVisble: false,
      activity_id: "",
      commentList: [],
      commentPage: 1,
      commentPageSize: 15,
      commentTotal: 0,
      commentSubPage: 1,
      commentSubPageSize: 3,
      root_id: "",
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        doing_status: "",
        title: "",
      },
      doingList: [
        {
          title: "全部",
          val: -1,
        },
        {
          title: "活动未开始",
          val: 1,
        },
        {
          title: "活动报名中",
          val: 2,
        },
        {
          title: "报名已截止",
          val: 3,
        },

        {
          title: "活动进行中",
          val: 4,
        },
        {
          title: "活动已结束",
          val: 5,
        },
      ],
      total: 0,
      ruleForm: {},
      fileList: [],
      rules: {
        activityTime: [{ required: true, message: "请选择活动时间" }],
        applyTime: [{ required: true, message: "请选择活动时间" }],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        thumb: [{ required: true, message: "请选择缩略图" }],
        join_type: [{ required: true, message: "请选择活动人群" }],
        status: [{ required: true, message: "请选择状态" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入活动内容", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入活动地点", trigger: "blur" },
        ],
        is_party: [
          {
            required: true,
            message: "请选择是否为党员活动",
            trigger: "change",
          },
        ],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
        like: "",
      },
      registerUserList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 删除评论
    delComment(item, index, type, subItem, subIndex) {
      if (type == "main") {
        // 主评论
        activity_comment_del({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.$set(
              this.commentList[index],
              "content",
              res.data.info.content
            );
            this.$set(
              this.commentList[index],
              "delete_time",
              res.data.info.delete_time
            );
          }
        });
      } else if (type == "sub") {
        // 子评论
        activity_comment_del({ id: subItem.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            this.$set(
              this.commentList[index].son_lists[subIndex],
              "content",
              res.data.info.content
            );
            this.$set(
              this.commentList[index].son_lists[subIndex],
              "delete_time",
              res.data.info.delete_time
            );
          }
        });
      }
    },
    // 审核评论
    auditComment(item, index, type, subItem, subIndex) {
      if (type == "main") {
        // 主评论
        activity_comment_audit({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审核成功！",
              type: "success",
            });
            this.$set(this.commentList[index], "audit_status", 2);
          }
        });
      } else if (type == "sub") {
        // 子评论
        activity_comment_audit({ id: subItem.id }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "审核成功！",
              type: "success",
            });
            this.$set(
              this.commentList[index].son_lists[subIndex],
              "audit_status",
              2
            );
          }
        });
      }
    },
    openComment(id) {
      this.activity_id = id;
      this.commentList = [];
      this.commentPage = 1;
      this.commentTotal = 0;
      this.commentPageSize = 15;
      this.getCommentList();
    },
    // 主评论
    getCommentList() {
      var data = {
        page: this.commentPage,
        page_size: this.commentPageSize,
        activity_id: this.activity_id,
        root_id: "",
      };
      activity_comment_lists(data).then((res) => {
        this.commentList = this.commentList.concat(res.data.lists.data);
        this.commentPage = res.data.lists.current_page;
        this.commentTotal = res.data.lists.total;
        this.commentPageSize = res.data.lists.per_page;
        this.commentVisble = true;
      });
    },
    //更多子评论
    moreSubComment(item, index) {
      if (item.son_count > item.son_lists.length) {
        this.commentSubPage = Math.trunc(item.son_lists.length / 3) + 1;
        this.root_id = item.id;
        this.getSubCommentList(index);
      }
      
    },
    // 子评论管理
    getSubCommentList(i) {
      var data = {
        page: this.commentSubPage,
        page_size: this.commentSubPageSize,
        activity_id: this.activity_id,
        root_id: this.root_id,
      };
      activity_comment_lists(data).then((res) => {
        this.commentList[i].son_lists = this.commentList[i].son_lists.concat(
          res.data.lists.data
        );
      });
    },
    // 导出
    derive() {
      let data = {
        id: this.registerUser.id,
      };
      const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
      user_export(data).then((res) => {
        loading.close();
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = res.name;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
    },
    UserCZhi() {
      this.registerUser.page = 1;
      this.registerUser.page_size = 15;
      this.registerUser.total = 0;
      this.registerUser.like = "";
      this.getRegisteredList();
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.thumb = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
    },
    activityChange(e) {
      this.ruleForm.applyTime = null;
    },
    applyChange(e) {
      if (e[0] <= this.ruleForm.applyTime[1]) {
        this.$message({
          message: "报名结束时间必须小于活动开始时间",
          type: "error",
        });
        this.ruleForm.activityTime = null;
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        doing_status: "",
        page: 1,
        page_size: 15,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.start_join_time = that.ruleForm.applyTime[0] / 1000;
          that.ruleForm.end_join_time = that.ruleForm.applyTime[1] / 1000;
          that.ruleForm.start_time = that.ruleForm.activityTime[0] / 1000;
          that.ruleForm.end_time = that.ruleForm.activityTime[1] / 1000;

          this.$confirm("确认提交？")
            .then(() => {
              editActivity(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    registerPageChange(current) {
      this.registerUser.page = current;
      this.getRegisteredList();
    },
    getRegisterUser(id) {
      this.userLoading = true;
      this.registerUser = {
        id,
        page: 1,
        page_size: 15,
        total: 0,
      };
      this.getRegisteredList();
    },
    getRegisteredList() {
      activityRegistered(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.data;
        this.registerUser.page = res.data.current_page;
        this.registerUser.total = res.data.total;
      });
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      activityDetail({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_id: Number(res.data.info.park_id),
          thumb: res.data.info.thumb,
          status: res.data.info.status,
          sort: res.data.info.sort,
          title: res.data.info.title,
          content: res.data.info.content,
          join_type: res.data.info.join_type,
          address: res.data.info.address,
          is_party: res.data.info.is_party,
          nature:res.data.info.nature
        };
        // that.ruleForm.applyTime = [];
        // that.ruleForm.activityTime = [];
        // that.ruleForm.applyTime[0] = res.data.info.start_join_time * 1000;
        // that.ruleForm.applyTime[1] = res.data.info.end_join_time * 1000;
        // that.ruleForm.activityTime[0] = res.data.info.start_time * 1000;
        // that.ruleForm.activityTime[1] = res.data.info.end_time * 1000;
        this.$set(that.ruleForm, "applyTime", [
          res.data.info.start_join_time * 1000,
          res.data.info.end_join_time * 1000,
        ]);
        this.$set(that.ruleForm, "activityTime", [
          res.data.info.start_time * 1000,
          res.data.info.end_time * 1000,
        ]);
        var list = res.data.info.thumb.split(",");
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delActivity({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }

            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ruleForm.start_join_time = that.ruleForm.applyTime[0] / 1000;
          that.ruleForm.end_join_time = that.ruleForm.applyTime[1] / 1000;
          that.ruleForm.start_time = that.ruleForm.activityTime[0] / 1000;
          that.ruleForm.end_time = that.ruleForm.activityTime[1] / 1000;

          this.$confirm("确认提交？")
            .then(() => {
              addActivity(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        thumb: "",
        status: 1,
        sort: 0,
        title: "",
        activityTime: null,
        applyTime: null,
        content: "",
        join_type: 1,
        address: "",
        is_party: 0,nature:''
      };
      this.clearPics = [];
      this.fileList = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      activityLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.comment_list {
  padding: 0 10px 20px;
  .more {
    text-align: center;
    border-radius: 6px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #d3e4f7;
    font-size: 15px;
    color: #409eff;
    cursor: pointer;
    &:hover {
      background: #c2d7f0;
    }
  }
  .comment_item {
    padding: 10px;
    .comment_user {
      .avatar {
        vertical-align: middle;
        margin-right: 10px;
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
      .userName {
        display: inline-block;
        font-size: 13px;
      }
    }
    .comment_content {
      padding-left: 50px;
      .contetns {
        margin-bottom: 10px;
        font-size: 15px;
        .samll_feedback {
          margin-right: 10px;
          color: #409eff;
        }
      }
      .comment_time {
        color: #9499a0;
        font-size: 13px;
        .time,
        .audit,
        .del {
          margin-right: 20px;
          display: inline-block;
        }
        .audit {
          color: #409eff;
          cursor: pointer;
        }
        .del {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }
  }
}
.comment_empty {
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.table-box {
  margin-top: 20px;
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
